import React from "react";
import { useSelector } from "react-redux";
import executionlog from "../../../../images/executionlog.png";

const LogEmitterTriggerPage = () => {
  const flow = useSelector((state) => state.integration.flow);

  return (
    <div className="ihub-edit-trigger">
      <p>
        The Log Emitter is a sophisticated trigger designed to elevate your
        logging by seamlessly integrating with multiple logging systems. This
        functionality ensures that your logs are not only captured but also
        efficiently routed to a designated logging system for comprehensive
        analysis, monitoring, and archiving.
      </p>
      <p>
        <b>When does this flow run?</b>
         </p>
         <p>This flow runs whenever there is a log event in other flows, which can be viewed in their respective execution logs.</p>
        <p>It takes the log data from the flow action and passes it to this flow, which then sends the data to your external logging system.</p>
        <img src={executionlog} width="60%" height="60%" />
        <p>
          <br/>
        <b>Configuration</b></p>
        <p>Configure the Action to POST data to a logging system like, Splunk, ELK, ChaosSeach, Sumo Logic etc</p>



    </div>
  );
};

export default LogEmitterTriggerPage;
